import React, { useRef, useEffect } from 'react';
import Lottie from 'lottie-react';

const LottieAvatar = ({ play }) => {
  const lottieRef = useRef();

  useEffect(() => {
    if (!lottieRef.current) return;
    if (play) {
      lottieRef.current.play();
    } else {
      lottieRef.current.pause();
    }
  }, [play]);

  return (
    <div style={{ width: 300, height: 300 }}>
      <Lottie
        lottieRef={lottieRef}
        animationData={require('./assets/lottie/talkingman.json')}
        loop={true}
        autoplay={false}
      />
    </div>
  );
};

export default LottieAvatar;
